export default class newsletter {
  /*
   * Fires first
   */
  constructor() {
    // Add events
    this.addEvents();
  }


  addEvents() {

    $('.js-newsletter-form').on('submit', e => {
      e.preventDefault();
      let emailAddress = $('.js-newsletter__input').val();
      let regexEmail = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;

      if (emailAddress.match(regexEmail)) {
        $('.js-newsletter__output').html('<strong>Thank you for signing up!</strong><br /><p>Keep an eye out for our great offers and updates</p>')
        $('.top-footer__newsletter').removeClass('opacity-40', 'pointer-events-none');
        // $.ajax({
        //     type: 'POST',
        //     url: ajaxObject.ajax_url,
        //     dataType: "json",
        //     data: {
        //         action: 'newsLetterRequest',
        //         emailAdress: emailAdress,
        //     },
        //     beforeSend: () => {
        //         $('.top-footer__newsletter').addClass('opacity-40', 'pointer-events-none');
        //     },
        //     success: (result) => {
        //         $('.js-newsletter__output').text('Registration successful')
        //         $('.top-footer__newsletter').removeClass('opacity-40', 'pointer-events-none');
        //     },
        // });

      } else {
        e.preventDefault();
        $('.js-newsletter__output').text('Please enter a valid email address');
        $('.js-newsletter__output').removeClass('hidden');
        $('.js-newsletter__input').addClass('bg-alert');
        $('.js-newsletter__input').addClass('border-warning');
      }

    });
  }

}
